import { z } from 'zod';
import { OrderFormPayloadBaseSchema } from './OrderForm';

export type BuyEventType = 'BuyAtProviderError'
  | 'BuyAtProviderFailed'
  | 'BuyAtProviderSuccess'
  | 'BuyAtProviderValidation'
  | 'BuyAtProviderValidationError'
  | 'BuyAtProviderValidationFailed'
  | 'BuyAtProviderValidationSuccess'
  | 'BuyButtonClick'
  | 'BuyBackendSubmitFailed'
  | 'BuyPaymentRedirect'
  | 'BuyShowSummary'
  | 'BuySubmit'
  | 'ExpressCheckoutButtonClick'
  | 'BeforeSubmitHook';

// Buy event payload schemas
export const BuyButtonClickPayloadSchema = OrderFormPayloadBaseSchema.extend({
  orderFormSummaryType: z.enum(['none', 'above-button', 'dialog']),
});

export type BuyEventTypePayloadMap = {
  BuyAtProviderError: undefined;
  BuyAtProviderFailed: undefined;
  BuyAtProviderSuccess: undefined;
  BuyAtProviderValidation: undefined;
  BuyAtProviderValidationError: undefined;
  BuyAtProviderValidationFailed: undefined;
  BuyAtProviderValidationSuccess: undefined;
  BuyButtonClick: z.infer<typeof BuyButtonClickPayloadSchema>;
  BuyBackendSubmitFailed: z.infer<typeof OrderFormPayloadBaseSchema>;
  BuyPaymentRedirect: undefined;
  BuyShowSummary: z.infer<typeof BuyButtonClickPayloadSchema>;
  BuySubmit: undefined;
  ExpressCheckoutButtonClick: undefined;
  BeforeSubmitHook: undefined;
};

export const BuyEventSchemaMap = {
  BuyAtProviderError: z.undefined(),
  BuyAtProviderFailed: z.undefined(),
  BuyAtProviderSuccess: z.undefined(),
  BuyAtProviderValidation: z.undefined(),
  BuyAtProviderValidationError: z.undefined(),
  BuyAtProviderValidationFailed: z.undefined(),
  BuyAtProviderValidationSuccess: z.undefined(),
  BuyButtonClick: BuyButtonClickPayloadSchema,
  BuyBackendSubmitFailed: OrderFormPayloadBaseSchema,
  BuyPaymentRedirect: z.undefined(),
  BuyShowSummary: BuyButtonClickPayloadSchema,
  BuySubmit: z.undefined(),
  ExpressCheckoutButtonClick: z.undefined(),
  BeforeSubmitHook: z.undefined(),
};